import React from "react";
import { fmtSaldoDuplo, itemIdUmBase, itemIdUmOp } from "../../utils/estoqueUm";

/** Exibe saldo na unidade base e, se houver UM operacional, o equivalente. */
export default function SaldoDuplo({
  qtd,
  unidades = [],
  idUmBase,
  idUmOp,
  row,
  className = "",
  dec = 3,
}) {
  const idBase = idUmBase || (row ? itemIdUmBase(row) : "");
  const idOp = idUmOp || (row ? itemIdUmOp(row) : "");
  const texto = fmtSaldoDuplo(qtd, unidades, idBase, idOp, dec);
  return <span className={className}>{texto}</span>;
}
